import { apiCall } from '../../utils/restclient'
import {
  GET_SCHEDULE_BY_ID,
  GET_SCHEDULE_BY_ID_SUCCESS,
  GET_SCHEDULE_BY_ID_ERROR,
  ADD_TO_SCHEDULE,
  ADD_TO_SCHEDULE_SUCCESS,
  ADD_TO_SCHEDULE_ERROR,
  GET_PATIENT,
  GET_PATIENT_NO_LOAD,
  GET_PATIENT_SUCCESS,
  GET_PATIENT_ERROR,
  GET_APPOINTMENT,
  GET_APPOINTMENT_NO_LOAD,
  GET_APPOINTMENT_SUCCESS,
  GET_APPOINTMENT_ERROR,
  EDIT_SCHEDULE,
  EDIT_SCHEDULE_SUCCESS,
  EDIT_SCHEDULE_ERROR,
  GET_CURRENT_SCHEDULE,
  GET_CURRENT_SCHEDULE_NO_LOAD,
  GET_CURRENT_SCHEDULE_SUCCESS,
  GET_CURRENT_SCHEDULE_ERROR,
  GET_VISIT_TYPE_GROUPS,
  GET_VISIT_TYPE_GROUPS_ERROR,
  GET_VISIT_TYPE_GROUPS_SUCCESS,
} from './CalendarConstants'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getScheduleInfo = (id) => {
  const endpoint = `api/v1/calendar/schedules/${id}`
  const action = {
    type: GET_SCHEDULE_BY_ID,
  }
  try {
    apiCall(
      endpoint,
      'GET',
      null,
      null,
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      {
        success: GET_SCHEDULE_BY_ID_SUCCESS,
        error: GET_SCHEDULE_BY_ID_ERROR,
      },
      null,
      null,
      0,
      false,
    )
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const addToSchedule = ({ TimeZone, Occurrences, Schedules, tabId }) => {
  const endpoint = `api/v1/calendar`
  const action = {
    type: ADD_TO_SCHEDULE,
  }

  const correctBodyObject = Occurrences ? { TimeZone, Occurrences } : { TimeZone, Schedules }
  try {
    apiCall(
      endpoint,
      'POST',
      null,
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      JSON.stringify(correctBodyObject),
      {
        success: ADD_TO_SCHEDULE_SUCCESS,
        error: ADD_TO_SCHEDULE_ERROR,
        extraData: {
          visitType: Occurrences?.Create[0]?.Type ? Occurrences.Create[0].Type : Schedules.Create[0].Type,
          tabId,
        },
      },
      null,
      null,
      0,
      false,
    )
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getPatient = (id, shouldShowLoading) => {
  const endpoint = `api/v1/patients/${id}`
  const action = {
    type: shouldShowLoading ? GET_PATIENT : GET_PATIENT_NO_LOAD,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'GET', null, null, {
      success: GET_PATIENT_SUCCESS,
      error: GET_PATIENT_ERROR,
      extraData: { patientId: id },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function getAppointmentInfo(appointmentId, shouldShowLoading = true) {
  const endpoint = `api/v1/visits/${appointmentId}`
  const action = {
    type: shouldShowLoading ? GET_APPOINTMENT : GET_APPOINTMENT_NO_LOAD,
  }
  apiCall(
    endpoint,
    'GET',
    null,
    null,
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    {
      success: GET_APPOINTMENT_SUCCESS,
      error: GET_APPOINTMENT_ERROR,
      extraData: { shouldShowLoading },
    },
    null,
    null,
    0,
    false,
  )
  return action
}

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export function editSchedule({ scheduleInfo, eventType, tabId }) {
  const endpoint = `api/v1/calendar`
  const action = {
    type: EDIT_SCHEDULE,
  }
  apiCall(
    endpoint,
    'POST',
    null,
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    JSON.stringify({
      ...scheduleInfo,
    }),
    {
      success: EDIT_SCHEDULE_SUCCESS,
      error: EDIT_SCHEDULE_ERROR,
      extraData: {
        visitType:
          eventType ||
          (scheduleInfo?.Occurrences?.Create ?
            scheduleInfo.Occurrences?.Create?.[0]?.Type
          : scheduleInfo.Schedules?.Create?.[0]?.Type),
        tabId,
      },
    },
    null,
    null,
    0,
    false,
  )
  return action
}

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const getCurrentSchedule = ({ fromDateTime, toDateTime, shouldShowLoading = true, tabId }) => {
  const endpoint = `api/v1/calendar?FromDateTime=${encodeURIComponent(
    fromDateTime,
  )}&ToDateTime=${encodeURIComponent(toDateTime)}`
  const action = {
    type: shouldShowLoading ? GET_CURRENT_SCHEDULE : GET_CURRENT_SCHEDULE_NO_LOAD,
  }
  try {
    apiCall(
      endpoint,
      'GET',
      null,
      null,
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      {
        success: GET_CURRENT_SCHEDULE_SUCCESS,
        error: GET_CURRENT_SCHEDULE_ERROR,
        extraData: { tabId, from: fromDateTime, to: toDateTime },
      },
      null,
      null,
      0,
      false,
    )
    return action
  } catch (e) {
    console.log(e)
  }
}
export function getVisitTypeGroups() {
  const endpoint = `api/v1/calendar/visitTypeGroups`
  const action = {
    type: GET_VISIT_TYPE_GROUPS,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'GET', null, null, {
      success: GET_VISIT_TYPE_GROUPS_SUCCESS,
      error: GET_VISIT_TYPE_GROUPS_ERROR,
    })
    return action
  } catch (e) {
    console.warn(e)
  }
}
